export default "__VITE_ASSET__HmfRar0u__"